module.exports = __webpack_public_path__ + "35a056d1268aecb4b2b0198969c4aead.svg";